import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector, RootState } from '../../store';
import { useNavigate } from 'react-router-dom';
import { getFormGroup, rmvMsgSccsFGr } from '../../store/feature/formGroup';

// icon
import AddIcon from '@mui/icons-material/Add';
import Toast from '../../components/atoms/toast';
import EventsLogSearch from '../../components/molecules/eventsLog/EventsLogSearch';
import EventsLogTable from '../../components/molecules/eventsLog/EventsLogTable';
import { getEventLogList } from '../../store/feature/eventLog';
import ListDataSkeleton from '../../components/template/skeleton/ListDataSkeleton';

const EventsLog = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState<object>({});
  const [defaultValue, setDefaultValue] = useState({});
  const { isLoadingEventLog } = useAppSelector((state: RootState) => state.evntLog);
  const { eventLogs } = useAppSelector((state: RootState) => state.user);

  const { dataFGroup, msgSccsFGr } = useAppSelector(
    (state: RootState) => state.fGroup
  );

  const handleCloseToast = () => {
    dispatch(rmvMsgSccsFGr());
  };

  useEffect(() => {
    if (Object.keys(eventLogs).length > 0) {
      dispatch(getEventLogList(params));
    }
  }, [params, eventLogs]);

  return (
    <ListDataSkeleton
      isLoading={isLoadingEventLog}
      isLoadingEvent={false}
      titleWidth={'300'}>
    <Box>
      <Typography variant="h3" fontFamily="Open Sans" sx={{ marginY: '20px' }}>
        Event Log
      </Typography>

      {/* <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/events-log/create')}
        sx={{ marginBottom: '18px' }}
      >
        <AddIcon /> Create
      </Button> */}
      <EventsLogSearch params={params} setParams={setParams} />
      <EventsLogTable
        data={dataFGroup}
        params={params}
        setParams={setParams}
        defaultValue={defaultValue}
        setDefaultValue={setDefaultValue}
      />
      <Toast
        severity="success"
        open={msgSccsFGr !== ''}
        handleClose={handleCloseToast}
        message={msgSccsFGr}
      />
    </Box>
    </ListDataSkeleton>
  );
};

export default EventsLog;
